// eslint-disable-next-line import/named
import { authTypes } from '../actions/auth_actions';

export default (state = {}, action) => {
  switch (action.type) {
    case authTypes.LOGIN:
      return {
        uid: action.uid,
        claim: action.claim,
        isAbleTo: action.isAbleTo,
        userData: action.userData,
      };
    case authTypes.SIGNOUT:
      return {};
    case authTypes.ADMINSIGNOUT:
      return {};
    case authTypes.ADMINSESSION:
      return {
        claim: action.claim,
        uid: action.uid,
        userData: action.userData,
      };
    case authTypes.COMPANYSESSION:
      return {
        claim: action.claim,
        uid: action.uid,
        userData: action.userData,
        claims: action.claims,
      };
    case authTypes.COMPANYSIGNOUT:
      return {};
    default:
      return state;
  }
};
